<style type="text/scss">
  @import "../../styles/vars.scss";

  .loader {
    border: 2px solid #f3f3f3;
    border-top: 2px solid map-get($colors, primary);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    animation: spin 1.6s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

<div class="loader" />